import { CardCategory } from '../../models/customer-application';

export const CARD_APPLICATION_MONTHLY_LIMIT_REGEX = /^[0-9]*[.,]?[0-9]+$/;
export const CARD_APPLICATION_MAX_CARDS = 5;

export const initialCardsStatePayment: Record<CardCategory, { cardName: string; monthlyLimit?: string; cardCategory?: CardCategory; isVirtual: boolean }[]> = {
    [CardCategory.ALL_FUELS_AND_GOODS]: [],
    [CardCategory.ALL_FUELS_AND_CAR_GOODS]: [],
    [CardCategory.ALL_FUELS]: [],
    [CardCategory.DIESEL]: [],
    [CardCategory.DISCOUNT]: [],
};

export const cardCategoryLabels: Record<CardCategory, string> = {
    [CardCategory.ALL_FUELS_AND_GOODS]: 'Kõik kütused ja kaubad (mootorikütused + elekter + toit ja jook + autokaubad + autopesu)',
    [CardCategory.ALL_FUELS_AND_CAR_GOODS]: 'Kõik kütused ja autokaubad (mootorikütused + elekter + autokaubad + autopesu)',
    [CardCategory.ALL_FUELS]: 'Kõik kütused (mootorikütused + elekter)',
    [CardCategory.DIESEL]: 'Diislikütus (diislikütus + Adblue/klaasipesu tankurist)',
    [CardCategory.DISCOUNT]: 'Sooduskaart',
};

export const CARD_CATEGORY_TO_ICON: Record<CardCategory, string> = {
    [CardCategory.ALL_FUELS_AND_GOODS]: 'all-products--gray',
    [CardCategory.ALL_FUELS_AND_CAR_GOODS]: 'fuels-and-motor-products--gray',
    [CardCategory.ALL_FUELS]: 'all-fuels--gray',
    [CardCategory.DIESEL]: 'diesel--gray',
    [CardCategory.DISCOUNT]: '',
};
